import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Container from "@mui/material/Container";
import DialogActions from "@mui/material/DialogActions";
import ContentCopy from "@mui/icons-material/ContentCopy";
import axios from "../../../api/axios";
import Divider from "@mui/material/Divider";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import UpdateIcon from "@mui/icons-material/Update";

import Stack from "@mui/material/Stack";
import { url } from "../../../configlink";

import {
  Typography,
  Grid,
  Select,
  MenuItem,
  FormGroup,
  FormControl,
  FormControlLabel,
  InputLabel,
  Box,
  responsiveFontSizes,
} from "@mui/material";
import { makeStyles } from "@mui/material/styles";

import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";

import "./price_table.css";
import { useLocation } from "react-router-dom";
import { BiRightArrow, BiRightArrowAlt } from "react-icons/bi";
import { useSelector } from "react-redux";

export default function PriceChange() {
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});

	let adminUser = useSelector((state) => state.userAdmin.userAdmin)

  const [userId, setUserId] = useState();
  const [userPriceData, setUserPriceData] = useState([]);
  const [userFullName, setUserFullName] = useState("");

  const [organizationName, setOrganizationName] = useState("");
  const [fullName, setFullName] = useState("");
  const [pi, setPi] = useState("");
  const [address, setAddress] = useState("");
  const [address2, setAddress2] = useState("");
  const [email, setEmail] = useState("");

  const [item, setItem] = useState(0);

  let loc = useLocation();
  let [selectedUserId3, setSelectedUserId3] = useState();

  useEffect(() => {
    let uId = loc.search.split("=")[1];
    setSelectedUserId3(uId);
  }, []);

  useEffect(() => {
    if (selectedUserId3 == undefined || selectedUserId3 == "") return;
    console.log("second dialog selectedUserId===" + selectedUserId3);
    getUserListDrpDown();

    fetch(
      `${url}/api/admin/get_userdetail_for_pricechange_dlg?userId=` +
        selectedUserId3, {
			credentials: 'include',
			headers: {
				'acgt-admin': adminUser
			},
        }
    )
      .then((data) => data.json())
      .then((data) => {
        if (data[0] !== "" && data[0] !== undefined)
          setUserFullName(data[0].organizationName + " - " + data[0].fullName);

        setOrganizationName(data[0].organizationName);
        setFullName(data[0].fullName);
      });
  }, [selectedUserId3]);

  const getUserListDrpDown = async () => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_userlists_for_pricepage_dropbox?userId=` +
          selectedUserId3, {
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
          }
      );

      setUserPriceData(response.data);
      if (response.data.length > 0) {
        console.log("selected User id ==" + response.data[0].UserId);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getRefUserDetail = async () => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_userdetail_for_pricechange_dlg`,
        {
          params: { userId: selectedUserId3 },
          withCredentials: true,
        }
      );

      if (response.data.length > 0) {
        setFullName(response.data[0].fullName);
        setOrganizationName(response.data[0].organizationName);
        setAddress(response.data[0].address);
        setAddress2(response.data[0].address2);
        setEmail(response.data[0].email);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getItems = async (x) => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_price_items_by_users`,
        {
          params: { userId: x },
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        }
      );
      setRows(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelectedUserChange = (event) => {
    setItem(event.target.value);
    getItems(event.target.value);
  };

  // const closeDialog = () => {
  //   setOpenDialog(null);
  // };

  const setUserInfo = (user_data) => {
    alert(user_data.fullName);
  };

  const handleCopyPrice = async () => {
    console.log("userId2===" + selectedUserId3 + "   from22=====" + item);

    try {
      const response = await axios.put(
        `${url}/api/admin/post_admin_user_price_change_lists`, 
        {
          params: { userId1: selectedUserId3, userId2: item }
        },
        {
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        }
      );
      //setRows(response.data);
      console.log("return value===" + response.data);
      if(response.data.message === 'success'){
        alert('success')
      }
    } catch (error) {
      console.error(error);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", type: "number", hide: true },

    {
      field: "CategoryName",
      headerName: "Category",
      type: "string",
      width: 250,
      editable: false,
    },
    {
      field: "Item",
      headerName: "Item",
      type: "string",
      width: 200,
      editable: false,
    },
    {
      field: "Activated",
      headerName: "Activated",
      type: "boolean",
      width: 80,
      editable: false,
    },
    {
      field: "ActivatedDate",
      headerName: "ActivatedDate",
      type: "string",
      width: 150,
      editable: false,
    },
    {
      field: "DeActivatedDate",
      headerName: "DeActivatedDate",
      type: "string",
      width: 150,
      editable: false,
    },
    {
      field: "Price",
      headerName: "Price",
      type: "string",
      width: 80,
      editable: false,
    },
    {
      field: "OrderItemId",
      headerName: "OrderItemId",
      type: "number",
      hide: true,
    },
    {
      field: "ItemDetailId",
      headerName: "ItemDetailId",
      type: "number",
      hide: true,
    },
  ];

  return (
    <div>
      <div>
        <div className="App2">
          <div className="header2">
            <h5 className="header-title2">Change the price</h5>
            <div className="header-menu2">
              <Button
                sx={{ borderRadius: 10, color: "var(--color-primary-purple)" }}
                startIcon={<ContentCopy />}
                onClick={handleCopyPrice}
              >
                Execute
              </Button>{" "}
            </div>
          </div>

          <Divider component="div" />

          <div className="content">
            <Grid container gap={2} alignItems="center">
              <Grid item xs={6}>
                <FormControl size="small" fullWidth>
                  <InputLabel id="demo-select-small-label">Category</InputLabel>
                  <Select
                    label="User Lists"
                    value={item}
                    onChange={handleSelectedUserChange}
                  >
                    <MenuItem value={0}>All </MenuItem>
                    {userPriceData.map((data, i) => (
                      <MenuItem value={data.UserId} key={data.UserId}>
                        {data.FullName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <Typography
                  variant="h6"
                  color="var(--color-primary-purple)"
                  style={{
                    marginLeft: "30px",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  To <BiRightArrowAlt size={30} />
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="h6">{userFullName}</Typography>
              </Grid>

              <Grid item xs={12} alignItems="top">
                <DataGrid
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        //  Hide columns status and traderName, the other columns will remain visible
                        id: false,
                        OrderItemId: false,
                        ItemDetailId: false,
                      },
                    },
                  }}
                  style={{ width: "100%", height: "800px" }}
                  columnHeaderHeight={45}
                  rowHeight={40}
                  rows={rows}
                  columns={columns}
                  sx={{
                    "& .MuiDataGrid-columnHeaders": {
                      color: "var(--color-primary-purple)",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontWeight: 700,
                    },
                  }}
                  pageSize={100}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
}
